import {Directive, Input, OnDestroy, TemplateRef} from "@angular/core";
import {FUIFormationService} from "./formation.service";
import {FUIFormationType} from "./formation.type";

/**
 * Structural directive used to register formation groups. It is used when there the need to load the formation group's content on demand
 */
@Directive({selector: "[formationGroup]"})
export class FUIFormatGroupDirective implements OnDestroy {
    title: string;

    constructor(private templateRef: TemplateRef<any>,
                private formationService: FUIFormationService) {
    }

    @Input()
    set formationGroup({title, visible, formControlNames, formationType, formationClass}: {
        title: string,
        visible?: boolean | Promise<boolean>,
        formControlNames?: string[] | string,
        formationType?: FUIFormationType,
        formationClass?: string
    }) {
        this.title = title;
        this.formationService.registerGroupTemplate(title, visible, formControlNames, formationType, formationClass, this.templateRef);
    }

    ngOnDestroy(): void {
        this.formationService.unregisterGroupTemplate(this.title);
    }
}
